import React, { useState } from "react";
import { isValidEmail } from "../../../utils";
import firebase from "../../../services/firebase";
import { Link } from "react-router-dom";
import { STATUS } from "../../../constants";
import { HospitalLogo } from "../../Shared/HospitalLogo";

const ResetPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [isEmailFormatError, setIsEmailFormatError] = useState(false);
  const [emailResetResult, setEmailResetResult] = useState({ status: STATUS.DEFAULT, error: "" });

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setEmailResetResult({
      status: STATUS.LOADING,
      error: "",
    });
    if (!isValidEmail(email)) {
      setIsEmailFormatError(true);
      setEmailResetResult({
        status: STATUS.DEFAULT,
        error: "",
      });
      return;
    }

    try {
      await firebase.auth.sendPasswordResetEmail(email);
      setEmailResetResult({
        status: STATUS.SUCCEED,
        error: "",
      });
    } catch (error) {
      setEmailResetResult({
        status: STATUS.FAILED,
        error: error.message,
      });
    }
  };

  return (
    <div className="container reset-password-container">
      <div className="columns is-centered">
        <div className="column is-one-third">
          <div className="has-text-centered">
            <HospitalLogo klassName="logo-large" />
          </div>

          <h1 className="has-text-centered forget-pwd-header">Forgot Your Password?</h1>

          <p className="has-text-centered forget-pwd-p">
            Enter your primary email address and we’ll send you instructions on how to reset your password.
          </p>

          <div className="field is-horizontal">
            <div className="field-label is-normal">
              <label className="label">EMAIL</label>
            </div>
            <div className="field-body">
              <div className="field">
                <p className="control">
                  <input
                    className={`${isEmailFormatError ? "is-danger " : ""}input is-radiusless is-size-7`}
                    type="text"
                    onChange={(e) => {
                      setIsEmailFormatError(false);
                      setEmail(e.target.value);
                    }}
                    value={email}
                  />
                </p>
              </div>
            </div>
          </div>

          {emailResetResult.status === STATUS.FAILED && (
            <article className="message is-danger">
              <div className="message-body">{emailResetResult.error}</div>
            </article>
          )}

          {emailResetResult.status === STATUS.SUCCEED && (
            <article className="message is-success">
              <div className="message-body">
                We have sent you an email with a link to reset your password, please have a look! Then you can click{" "}
                <Link to="/admin">
                  <small>Back To Sign In Page</small>
                </Link>{" "}
                to sign in again.
              </div>
            </article>
          )}

          <div className="field">
            <div className="control">
              <button
                className={`button is-link is-size-7 is-radiusless is-fullwidth ${
                  !isEmailFormatError && emailResetResult.status === STATUS.LOADING ? "is-loading" : ""
                }`}
                disabled={isEmailFormatError}
                type="button"
                onClick={handleResetPassword}
              >
                Send Reset Instructions
              </button>
            </div>
          </div>

          <div className="field">
            <Link to="/admin">Back To Sign In Page</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
